var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CreateGroup"},[_c('NewForm',{attrs:{"data":_vm.formData},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }